import { toolIcons } from "../Assets/images/image";
import BillingDetails from "../Components/Tools/Merchant Management/BillingDetails";
import Details from "../Components/Tools/Merchant Management/Details";
import MDRPercentage from "../Components/Tools/Merchant Management/MDRPercentage";
import HoldAndDeposite from "../Components/Tools/HoldAndDeposite";
import FlagSubmitted from "../Components/Tools/FlagSubmitted";
import PendingPayoutRequest from "../Components/Tools/Merchant Management/PendingPayoutRequest";
import PendingVendorRequest from "../Components/Tools/Merchant Management/PendingVendorRequest";
import UploadChargeback from "../Components/Tools/Merchant Management/UploadChargeback";
import Reconciliation from "../Components/Tools/Merchant Management/Reconciliation";
import WalletBalance from "../Components/Tools/WalletBalance";
import SubmittedFraudManagement from "../Components/Tools/Merchant Management/SubmittedFraudManagement";
import ToolsSubmittedPayinRouting from "../Components/Tools/SubmittedPayinRouting";
import ToolsSubmittedRoutingEkyc from "../Components/Tools/EkycRoutingSubmitted";
import CallBackPayout from "../Components/Tools/CallBackPayout";
import PayoutApiTest from "../Components/Tools/PayoutApiTest";
import RequestedWithdraw from "../Components/Tools/Merchant Management/Withdraw/RequestedWithdraw";
import SubmittedUser from "../Components/Tools/UserManagement/SubmittedUser";
import ToolsPayoutSubmitted1 from "../Components/Tools/PayoutRoutingSubmitted1";
import FrmRoutingTable from "../Components/Tools/FrmRoutingTable";
import PayoutFrmRoutingTable from "../Components/Tools/PayoutFrmRoutingTable";
import WhitelistingRule from "../Components/Tools/WhitelistingRule";
import CheckBalance from "../Components/Tools/CheckBalance";
import IPManagement from "../Components/Tools/Merchant Management/IPManagement";

// registry of UI title, icon, route, component

export const toolUIIconMap = [
  {
    title: "Merchant Details",
    icon: toolIcons?.MerchantDetails,
    accessorKey: "Merchant Details View",
    detailKey: "MerchantDetails",
    component: Details,
  },
  {
    title: "User Management",
    icon: toolIcons?.userManagement,
    accessorKey: "User View",
    detailKey: "SubmittedUser",
    component: SubmittedUser,
  },
  {
    title: "Withdraw",
    icon: toolIcons?.toolWithdraw,
    accessorKey: "Withdraw Request Approve / Reject",
    detailKey: "RequestedWithdraw",
    component: RequestedWithdraw,
  },
  {
    title: "MDR",
    icon: toolIcons?.MDR,
    accessorKey: "MDR Edit",
    detailKey: "MDR",
    component: MDRPercentage,
  },
  {
    title: "Hold and Deposit",
    icon: toolIcons?.HoldDepo,
    accessorKey: "Hold Edit",
    detailKey: "HoldAndDeposite",
    component: HoldAndDeposite,
  },
  {
    title: "Flag Management",
    icon: toolIcons?.FlagManagement,
    accessorKey: "Flag Edit",
    detailKey: "FlagSubmitted",
    component: FlagSubmitted,
  },
  {
    title: "Pending Payout Request",
    icon: toolIcons?.pendingpayout,
    accessorKey: "Pending Payout Request Approve / Reject",
    detailKey: "pendingpayout",
    component: PendingPayoutRequest,
  },
  {
    title: "Pending Vendor Request",
    icon: toolIcons?.pendingvendor,
    accessorKey: "Pending Vendor Request Approve / Reject",
    detailKey: "pendingvendor",
    component: PendingVendorRequest,
  },
  {
    title: "Upload Chargeback",
    icon: toolIcons?.uploadChargeback,
    accessorKey: "Upload Chargeback",
    detailKey: "UploadChargeback",
    component: UploadChargeback,
  },
  {
    title: "Reconciliation",
    icon: toolIcons?.reconciliationTools,
    accessorKey: "Reconciliation Edit",
    detailKey: "Reconciliation",
    component: Reconciliation,
  },
  {
    title: "Wallet Balance",
    icon: toolIcons?.Wallet,
    accessorKey: "Wallet Balance Approve / Reject",
    detailKey: "WalletBalance",
    component: WalletBalance,
  },
  {
    title: "Pay-in Routing",
    icon: toolIcons?.PayinRouting,
    accessorKey: "Payin Routing View",
    detailKey: "PayinRouting",
    component: ToolsSubmittedPayinRouting,
  },
  {
    title: "Payout Routing",
    icon: toolIcons?.toolPayout,
    accessorKey: "Payout Routing View",
    detailKey: "PayoutSubmitted",
    component: ToolsPayoutSubmitted1,
  },
  {
    title: "e-KYC Routing",
    icon: toolIcons?.eKYC,
    accessorKey: "E kyc Routing View",
    detailKey: "Ekyc",
    component: ToolsSubmittedRoutingEkyc,
  },
  {
    title: "Fraud Management",
    icon: toolIcons?.FraudManagement,
    accessorKey: "Fraud Management",
    detailKey: "FraudManagement",
    component: SubmittedFraudManagement,
  },
  {
    title: "CallBack API Test",
    icon: toolIcons?.callbackapitest,
    accessorKey: "Payout Callback Test",
    detailKey: "callbackapitest",
    component: CallBackPayout,
  },
  {
    title: "Whitelist Rule",
    icon: toolIcons?.callbackapitest,
    accessorKey: "Whitelist Rule",
    detailKey: "WhitelistingRule",
    component: WhitelistingRule,
  },
  {
    title: "Payout API Test",
    icon: toolIcons?.payoutApiTest,
    accessorKey: "Payout API Test",
    detailKey: "payoutApiTest",
    component: PayoutApiTest,
  },
  {
    title: "FRM Routing Rules",
    icon: toolIcons?.routingRules,
    accessorKey: "FRM ROUTING_RULES VIEW",
    detailKey: "frmRoutingTable",
    component: FrmRoutingTable,
  },
  {
    title: "Payout FRM Routing Rules",
    icon: toolIcons?.routingRules,
    accessorKey: "PAYOUT FRM ROUTING_RULES VIEW",
    detailKey: "payoutFrmRoutingTable",
    component: PayoutFrmRoutingTable,
  },
  {
    title: "Check Payout Balance",
    icon: toolIcons?.Wallet,
    accessorKey: "CHECK PAYOUT BALANCE",
    detailKey: "CheckBalance",
    component: CheckBalance,
  },
  {
    title: "Billing Details",
    icon: toolIcons?.Billing,
    accessorKey: "Billing View",
    detailKey: "billingDetails",
    component: BillingDetails,
  },
  {
    title: "IP Management",
    icon: toolIcons?.IPManagementIcon,
    accessorKey: "IP Register View",
    detailKey: "ipManagement",
    component: IPManagement,
  },
];
